// extracted by mini-css-extract-plugin
var _1 = "empty-plans-list__Wbo8N";
var _2 = "empty-plans-list-text__rk__r";
var _3 = "legalDisclosure__LEbcb";
var _4 = "plans-container__Ox2e3";
var _5 = "plans-list-grid__cfdrM";
export { _1 as "emptyPlansList", _2 as "emptyPlansListText", _3 as "legalDisclosure", _4 as "plansContainer", _5 as "plansListGrid" }
